<script>

    import { facturamaClientStore } from '../stores'

    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'

</script>

<div class="subtitle is-5">Datos de facturación</div>

<DetailsCard title={$facturamaClientStore.name} meta={$facturamaClientStore.rfc}>
    <DetailsFields>
        <DetailsField label="Correo" value={$facturamaClientStore.email} mono />
        <DetailsField label="Domicilio fiscal">
            <div>
                <div>{ $facturamaClientStore.location.street }</div>
                <div>{ $facturamaClientStore.location.number }, { $facturamaClientStore.location.apartment || '' }</div>
                <div>{ $facturamaClientStore.location.colony }</div>
                <div><b>{ $facturamaClientStore.location.zipcode }</b>, { $facturamaClientStore.location.city }, { $facturamaClientStore.location.state }</div>
            </div>
        </DetailsField>
    </DetailsFields>
</DetailsCard>
